
<div class="l-page">
  <div class="b-authentication">
    <div class="b-meetings_auth-logo-wrapper">
      <div class="b-meetings_auth-logo"></div>
    </div>
    <div class="b-authentication-wrapper_animation">
      <div class="b-authentication-wrapper">
        <div class="b-authentication-content" [@parentAnimation]>
          <ui-view></ui-view>
        </div>
      </div>
    </div>
  </div>
</div>